// Gambiko : page collection (sections/gk-collection.liquid).
// Filtres et tri par la Section Rendering API avec pushState, tiroirs mobiles (focus piégé, Échap),
// « Voir plus » chargé sur place, sélecteur de variantes (carte sur ordinateur, feuille sur mobile).
// L'ajout au panier passe par assets/gk-ajout-panier.js (attribut data-gk-add).
(() => {
  if (window.gkCollection) return;
  window.gkCollection = true;

  const R = document.querySelector('[data-gk-coll]');
  if (!R) return;

  const mq = window.matchMedia('(max-width: 989px)');
  const form = R.querySelector('[data-gk-form]');
  const sectionId = R.dataset.section;
  const sheet = R.querySelector('[data-gk-sheet]');
  const sheetPanel = R.querySelector('[data-gk-sheet-panel]');
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])';

  const store = {
    get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) { /* stockage indisponible */ } },
  };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

  /* ---------- Panneaux : filtres (tiroir mobile), tri (menu ou tiroir), feuille de variantes ---------- */
  let current = null; // { el, opener, modal, onClose }

  function lock(on) { document.documentElement.classList.toggle('gk-lock', on); }

  function openLayer(el, opener, { modal, focus, onClose } = {}) {
    closeLayer(false);
    current = { el, opener, modal, onClose };
    if (modal) lock(true);
    (focus || el.querySelector(FOCUSABLE))?.focus({ preventScroll: true });
  }

  function closeLayer(restore = true) {
    if (!current) return;
    const { opener, modal, onClose } = current;
    current = null;
    onClose?.();
    if (modal) lock(false);
    if (restore && opener && document.contains(opener)) opener.focus({ preventScroll: true });
  }

  function openPanel(name, opener) {
    const el = R.querySelector(`[data-gk-panel="${name}"]`);
    if (!el) return;
    const modal = mq.matches;
    el.classList.add('is-open');
    if (modal) { el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); }
    const toggle = name === 'tri' ? R.querySelector('[data-gk-sort-toggle]') : null;
    toggle?.setAttribute('aria-expanded', 'true');
    const focus = modal ? el.querySelector('[data-gk-close]') : el.querySelector('input:checked') || el.querySelector('input');
    openLayer(el, opener, {
      modal, focus,
      onClose: () => {
        el.classList.remove('is-open');
        el.removeAttribute('role');
        el.removeAttribute('aria-modal');
        toggle?.setAttribute('aria-expanded', 'false');
      },
    });
  }

  document.addEventListener('keydown', (e) => {
    if (!current) return;
    if (e.key === 'Escape') { e.preventDefault(); closeLayer(); return; }
    if (e.key !== 'Tab' || !current.modal) return;
    const items = [...current.el.querySelectorAll(FOCUSABLE)].filter((n) => n.offsetParent !== null);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!current.el.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  });

  // Clic hors du menu de tri ou du sélecteur de la carte (ordinateur) : fermeture.
  document.addEventListener('click', (e) => {
    if (!current || current.modal) return;
    const path = e.composedPath();
    if (path.includes(current.el) || (current.opener && path.includes(current.opener))) return;
    closeLayer(false);
  });

  // Le panier s'ouvre après un ajout : on ferme le sélecteur.
  document.addEventListener('cart:open', () => { if (current?.el.matches('.gk-pick, [data-gk-sheet-panel]')) closeLayer(false); });

  /* ---------- Filtres et tri ---------- */
  function buildUrl() {
    const params = new URLSearchParams();
    for (const [k, v] of new FormData(form)) {
      if (v === '') continue;
      if (k === 'sort_by' && v === R.dataset.sortDefaut) continue;
      params.append(k, v);
    }
    const qs = params.toString();
    return R.dataset.url + (qs ? '?' + qs : '');
  }

  let ctrl = null;
  async function load(url, { push = true, syncInputs = false } = {}) {
    ctrl?.abort();
    ctrl = new AbortController();
    R.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId), { signal: ctrl.signal });
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const next = doc.querySelector('[data-gk-coll]');
      if (!next) throw new Error('section introuvable');
      const names = new Set([...R.querySelectorAll('[data-gk-zone]')].map((z) => z.dataset.gkZone));
      for (const name of names) {
        const mine = R.querySelectorAll(`[data-gk-zone="${name}"]`);
        const theirs = next.querySelectorAll(`[data-gk-zone="${name}"]`);
        mine.forEach((z, i) => { if (theirs[i]) z.innerHTML = theirs[i].innerHTML; });
      }
      // Valeurs de filtre sans résultat : grisées, sans toucher à ce qui est coché.
      next.querySelectorAll('[data-gk-form] input[type="checkbox"]').forEach((n) => {
        const mine = [...form.querySelectorAll(`input[type="checkbox"]`)].find((i) => i.name === n.name && i.value === n.value);
        if (!mine) return;
        mine.disabled = n.disabled;
        mine.closest('.gk-fo')?.classList.toggle('is-off', n.disabled);
        if (syncInputs) mine.checked = n.checked;
      });
      if (syncInputs) {
        next.querySelectorAll('input[name]').forEach((n) => {
          if (n.type === 'checkbox') return;
          const mine = [...R.querySelectorAll('input[name]')].find((i) => i.name === n.name && (n.type !== 'radio' || i.value === n.value));
          if (!mine) return;
          if (n.type === 'radio') mine.checked = n.checked;
          else mine.value = n.value;
        });
        initPrix();
      }
      if (push) history.pushState({ gk: true }, '', url);
      initPopulaires();
    } catch (err) {
      if (err.name === 'AbortError') return;
      console.error('Gambiko filtres :', err);
      window.location.href = url;
    } finally {
      R.removeAttribute('aria-busy');
    }
  }

  const apply = () => load(buildUrl());

  if (form) {
    form.addEventListener('submit', (e) => { e.preventDefault(); apply(); });
    form.addEventListener('change', (e) => {
      const t = e.target;
      if (t.matches('[data-gk-prix-r]')) return; // géré à part
      if (t.name === 'sort_by' && current && !current.modal) closeLayer();
      apply();
    });
  }
  // Les boutons radio du tri sont rattachés au formulaire par l'attribut form, hors de son arbre DOM.
  R.querySelectorAll('input[name="sort_by"]').forEach((r) => r.addEventListener('change', () => {
    if (current && !current.modal) closeLayer();
    apply();
  }));

  function clearInputs(names, value) {
    form.querySelectorAll('input').forEach((i) => {
      if (names && !names.includes(i.name)) return;
      if (i.type === 'checkbox') { if (value === undefined || i.value === value) i.checked = false; }
      else if (i.type === 'number') i.value = '';
    });
    initPrix();
  }

  /* Prix : deux curseurs synchronisés avec les champs min / max */
  function initPrix() {
    R.querySelectorAll('[data-gk-prix]').forEach((box) => {
      const max = Number(box.dataset.max) || 0;
      const rMin = box.querySelector('[data-gk-prix-r="min"]'), rMax = box.querySelector('[data-gk-prix-r="max"]');
      const nMin = box.querySelector('[data-gk-prix-n="min"]'), nMax = box.querySelector('[data-gk-prix-n="max"]');
      const fill = box.querySelector('[data-gk-prix-fill]');
      const paint = () => {
        const a = Number(rMin.value), b = Number(rMax.value);
        fill.style.left = (max ? (a / max) * 100 : 0) + '%';
        fill.style.right = (max ? 100 - (b / max) * 100 : 0) + '%';
      };
      rMin.value = nMin.value === '' ? 0 : nMin.value;
      rMax.value = nMax.value === '' ? max : nMax.value;
      paint();
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      const fromRange = () => {
        if (Number(rMin.value) > Number(rMax.value)) {
          if (document.activeElement === rMin) rMin.value = rMax.value; else rMax.value = rMin.value;
        }
        nMin.value = Number(rMin.value) > 0 ? rMin.value : '';
        nMax.value = Number(rMax.value) < max ? rMax.value : '';
        paint();
      };
      rMin.addEventListener('input', fromRange);
      rMax.addEventListener('input', fromRange);
      rMin.addEventListener('change', apply);
      rMax.addEventListener('change', apply);
      const fromNumber = () => {
        rMin.value = nMin.value === '' ? 0 : Math.min(Number(nMin.value), max);
        rMax.value = nMax.value === '' ? max : Math.min(Number(nMax.value), max);
        paint();
      };
      nMin.addEventListener('input', fromNumber);
      nMax.addEventListener('input', fromNumber);
    });
  }

  /* ---------- Voir plus ---------- */
  async function voirPlus(link) {
    link.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(link.href + (link.href.includes('?') ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId));
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const grid = R.querySelector('[data-gk-grid]');
      const items = [...doc.querySelectorAll('[data-gk-grid] > li')];
      items.forEach((li) => grid.append(document.importNode(li, true)));
      const zone = R.querySelector('[data-gk-more-zone]');
      const nextZone = doc.querySelector('[data-gk-more-zone]');
      if (zone && nextZone) zone.replaceWith(document.importNode(nextZone, true));
      const firstNew = grid.children[grid.children.length - items.length];
      firstNew?.querySelector('.gk-pcard__name a')?.focus({ preventScroll: true });
    } catch (err) {
      console.error('Gambiko voir plus :', err);
      window.location.href = link.href;
    }
  }

  /* ---------- État vide : « Les plus choisis » de la collection, sans filtre ---------- */
  async function initPopulaires() {
    const box = R.querySelector('[data-gk-populaires]');
    if (!box || box.dataset.ready) return;
    box.dataset.ready = '1';
    try {
      const url = box.dataset.gkPopulaires;
      const res = await fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId));
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const items = [...doc.querySelectorAll('[data-gk-grid] > li')].slice(0, 4);
      if (!items.length) return;
      const grid = box.querySelector('[data-gk-pop-grid]');
      items.forEach((li) => grid.append(document.importNode(li, true)));
      box.hidden = false;
    } catch (err) {
      console.error('Gambiko plus choisis :', err);
    }
  }

  /* ---------- Sélecteur de variantes ---------- */
  function picker(card, trigger) {
    const data = JSON.parse(card.querySelector('[data-gk-variantes]').textContent);
    const start = data.variantes.find((v) => v.dispo) || data.variantes[0];
    const sel = start.options.slice();
    const mobile = mq.matches;
    const el = mobile ? sheetPanel : document.createElement('div');
    if (!mobile) {
      el.className = 'gk-pick';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-label', R.dataset.choisir);
      card.querySelector('.gk-pcard__visuel').append(el);
    }
    const close = `<button type="button" class="gk-pick__x" data-gk-pick-close aria-label="${esc(R.dataset.fermer)}"><svg width="${mobile ? 22 : 16}" height="${mobile ? 22 : 16}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${mobile ? 1.5 : 1.6}" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg></button>`;

    const match = () => data.variantes.find((v) => v.options.every((o, i) => o === sel[i]));

    function render(focusKey) {
      const variant = match();
      let html = '';
      if (mobile) {
        html += `<div class="gk-pick__top"><div class="gk-sheet__prod">${data.image ? `<img class="gk-sheet__thumb" src="${esc(data.image)}" alt="" width="52" height="64">` : ''}<div class="gk-sheet__name">${esc(data.titre)}<span>${esc(variant ? variant.prix : '')}</span></div></div>${close}</div>`;
      }
      data.options.forEach((opt, i) => {
        const lab = `<span class="gk-pick__lab" id="gk-pick-${i}">${esc(opt.nom)}</span>`;
        html += !mobile && i === 0 ? `<div class="gk-pick__top">${lab}${close}</div>` : lab;
        html += `<div class="gk-pick__pills${opt.valeurs.length === 2 ? ' gk-pick__pills--2' : ''}" role="group" aria-labelledby="gk-pick-${i}">`;
        opt.valeurs.forEach((val) => {
          const cands = data.variantes.filter((v) => v.options[i] === val && v.options.every((o, j) => j === i || o === sel[j]));
          const exists = data.variantes.some((v) => v.options[i] === val);
          const off = !cands.some((v) => v.dispo);
          html += `<button type="button" class="gk-pick__pill${off ? ' is-off' : ''}" data-i="${i}" data-v="${esc(val)}" aria-pressed="${sel[i] === val}"${exists ? '' : ' disabled'}>${esc(val)}</button>`;
        });
        html += '</div>';
      });
      const ok = variant && variant.dispo;
      html += `<button type="button" class="gk-pick__add"${ok ? ` data-gk-add="${variant.id}" data-busy="${esc(R.dataset.busy)}" data-error="${esc(R.dataset.error)}"` : ' disabled'}>${esc(ok ? R.dataset.ajouter : R.dataset.epuise)}</button>`;
      el.innerHTML = html;
      if (focusKey) el.querySelector(`[data-i="${focusKey[0]}"][data-v="${CSS.escape(focusKey[1])}"]`)?.focus();
    }

    el.onclick = (e) => {
      const pill = e.target.closest('.gk-pick__pill');
      if (pill) {
        const i = Number(pill.dataset.i), val = pill.dataset.v;
        sel[i] = val;
        if (!match()) {
          const alt = data.variantes.filter((v) => v.options[i] === val);
          const pick = alt.find((v) => v.dispo) || alt[0];
          if (pick) pick.options.forEach((o, j) => { sel[j] = o; });
        }
        render([i, val]);
        return;
      }
      if (e.target.closest('[data-gk-pick-close]')) closeLayer();
    };

    render();
    trigger.setAttribute('aria-expanded', 'true');
    if (mobile) sheet.hidden = false;
    openLayer(el, trigger, {
      modal: mobile,
      focus: el.querySelector('.gk-pick__pill[aria-pressed="true"]') || el.querySelector('.gk-pick__pill'),
      onClose: () => {
        trigger.setAttribute('aria-expanded', 'false');
        if (mobile) { sheet.hidden = true; el.innerHTML = ''; el.onclick = null; }
        else el.remove();
      },
    });
  }

  /* ---------- Délégation des clics ---------- */
  R.addEventListener('click', (e) => {
    const t = e.target;
    let n;

    if ((n = t.closest('[data-gk-ftoggle]'))) {
      const on = !R.classList.contains('is-filtres');
      R.classList.toggle('is-filtres', on);
      n.setAttribute('aria-expanded', String(on));
      store.set('gk-filtres', on ? '1' : '0');
      return;
    }
    if ((n = t.closest('[data-gk-sort-toggle]'))) {
      e.stopPropagation();
      if (current?.el.dataset.gkPanel === 'tri') closeLayer(); else openPanel('tri', n);
      return;
    }
    if ((n = t.closest('[data-gk-open]'))) { openPanel(n.dataset.gkOpen, n); return; }
    if ((n = t.closest('[data-gk-fg]'))) {
      n.setAttribute('aria-expanded', String(n.getAttribute('aria-expanded') !== 'true'));
      return;
    }
    if ((n = t.closest('[data-gk-remove]'))) {
      e.preventDefault();
      clearInputs(n.dataset.gkRemove.split(','), n.dataset.gkValue);
      apply();
      return;
    }
    if ((n = t.closest('[data-gk-clear]'))) {
      e.preventDefault();
      clearInputs();
      apply();
      return;
    }
    if ((n = t.closest('[data-gk-more]'))) { e.preventDefault(); voirPlus(n); return; }
    if ((n = t.closest('[data-gk-choisir]'))) {
      e.preventDefault();
      e.stopPropagation();
      const card = n.closest('.gk-pcard');
      const already = current && current.opener === n;
      closeLayer(false);
      if (!already) picker(card, n);
      return;
    }
    if ((n = t.closest('[data-gk-close]'))) { closeLayer(); }
  });

  /* ---------- Démarrage ---------- */
  if (store.get('gk-filtres') === '1' && R.querySelector('[data-gk-ftoggle]')) {
    R.classList.add('is-filtres');
    R.querySelector('[data-gk-ftoggle]').setAttribute('aria-expanded', 'true');
  }
  R.querySelectorAll('[data-gk-choisir]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  initPrix();
  initPopulaires();
  history.replaceState({ gk: true }, '', location.href);
  window.addEventListener('popstate', () => {
    closeLayer(false);
    load(location.href, { push: false, syncInputs: true });
  });
  // Passage ordinateur / mobile : les panneaux changent de nature, on les ferme.
  let mobile = mq.matches;
  mq.addEventListener('change', () => {
    if (mq.matches === mobile) return;
    mobile = mq.matches;
    closeLayer(false);
  });
})();
